import angular from 'angular';
import {
  ssDialogService,
  loaderService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-nav-demo-dialog.controller';
import template from './edit-nav-demo-dialog.html';
import nameMessagesTpl from './name.messages.html';


export class dialogService {
  getOptions($event, {
    demo
  }) {
    return {
      controller,
      controllerAs: 'editNavDemoDialogVM',
      locals: {
        demo,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.demo.editNavDemoDialog', [
  ssDialogService,
  loaderService,
  alerts,
])
  .service('editNavDemoDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('name.messages.html', nameMessagesTpl);
  })
  .name;

console.log('app.components.demo.editNavDemoDialog created');
